import React, { useEffect, useState } from "react";
import SbuxTabs from "../../components/SbuxTabs";
import QuickConnects from "./quickConnects";
import History from "./history";
import Metrics from "./metrics";
import Resources from "./resources";
import Current from "./current";
import Manager from "./manager";
import Admin from "./admin";
import { Box } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../store/types";
import { getActiveTabId } from "../../services/tabs";
import defaultSettingsConfig from "../../components/SbuxSettings/config/default.json";
import {
  getAdminSelector,
  getManagerOrSupervisorSelector,
  getReOrderedTablistSelector,
} from "../../selectors/settingsSelector";
import { getActiveTabIdSelector } from "../../selectors/tabsSelector";
import { useNavigate } from "react-router-dom";

const ContentTabs = () => {
  const dispatch = useAppDispatch();
  const admin = useAppSelector(getAdminSelector);
  const managerOrSupervisor = useAppSelector(getManagerOrSupervisorSelector);
  const reOrderedTablist = useAppSelector(getReOrderedTablistSelector);
  const activeTabId = useAppSelector(getActiveTabIdSelector);
  const navigate = useNavigate();

  const [tabList, setTabList] = useState<
    { tabId: string; label: string; visible: boolean }[]
  >([]);

  useEffect(() => {
    reOrderedTablist.length === 0
      ? setTabList(
          defaultSettingsConfig.config.tabOrder as {
            tabId: string;
            label: string;
            visible: boolean;
          }[],
        )
      : setTabList(reOrderedTablist);
  }, [reOrderedTablist]);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    dispatch(getActiveTabId(newValue));
    const tabRoutes: Record<string, string> = {
      tab1: "/current",
      tab2: "/quick-connects",
      tab3: "/metrics",
      tab4: "/history",
      tab5: "/resources",
      tab6: "/manager",
      tab7: "/admin",
    };
    navigate(tabRoutes[newValue] || "/");
  };
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        width: "100%",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <SbuxTabs
        handleTabChange={handleTabChange}
        tabList={tabList}
        tabPanelList={[
          {
            tabPanelId: "tab1",
            component: <Current />,
            visible: true,
          },

          {
            tabPanelId: "tab2",
            component: activeTabId === "tab2" && <QuickConnects />,
            visible: true,
          },
          {
            tabPanelId: "tab3",
            component: activeTabId === "tab3" && <Metrics />,
            visible: true,
          },
          {
            tabPanelId: "tab4",
            component: activeTabId === "tab4" && <History />,
            visible: true,
          },
          {
            tabPanelId: "tab5",
            component: activeTabId === "tab5" && <Resources />,
            visible: true,
          },
          {
            tabPanelId: "tab6",
            component: activeTabId === "tab6" && <Manager />,
            visible: admin ? true : managerOrSupervisor,
          },
          {
            tabPanelId: "tab7",
            component: activeTabId === "tab7" && <Admin />,
            visible: admin,
          },
        ]}
      />
    </Box>
  );
};

export default ContentTabs;
